import React, { Component } from "react";
import MainMenu from "./components/mainMenu";
import SubNavigation from "./components/subNavigation";
import TopBanner from "./components/topBanner";
import AnimatedBackground from "./components/animatedBackground";
import Footer from "./components/footer";

export default class PrivacyPolicy extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		document.title = "QwixSkinz || Privacy Policy";
	}
	componentWillUnmount() {}

	render() {
		return (
			<React.Fragment>
				<MainMenu />
				<TopBanner
					bannerHeight="short"
					title="Privacy Policy"
					description=""
					images={["alpine-ski-suits.png"]}
				/>

				<SubNavigation location={this.props.location} refs={this.refs} />

				<div className="qs-b">
					<div className="container block-wrap behind-trees">
						<div className="d-flex flex-row">
							<div className="col content green">
								<p className="lead">
									Welcome to qwixskinz.com. Before using this Site please read
									the terms and conditions carefully. By accessing, browsing and
									using this Site, you are signifying your consent to be bound
									by the Terms and Conditions. The Terms and Conditions and the
									related documents will be revised from time to time. We
									recommend that you review these documents regularly, to ensure
									you are aware of any revisions.
								</p>
								<br />
								<br />
								<div ref="introduction">
									<h3 className="title">Introduction</h3>

									<p>
										At QwixSkinz we believe that when you visit the
										qwixskinz.com website (the "Site"), your personal
										information deserves protection. QwixSkinz has prepared this
										Privacy Policy to let you know what we can, and cannot do
										with your personal information, and to ensure that you
										understand our commitment to providing you with a secure and
										safe experience.
									</p>
									<p>
										It is always your decision as to whether you wish to use the
										Site and provide us with information about yourself. Unless
										you give it to us we will not record or use your personal
										information.
									</p>
								</div>
								<br />
								<br />
								<div ref="personalinfo">
									<h3 className="title">Collection of Personal Information</h3>
									<p>
										You may visit the Site without registering and directly
										providing any personal information. However you will need to
										register and provide personal information if you wish to
										access particular portions of the Site and to use specific
										functions that are available to you. In other instances,
										such as when sending QwixSkinz an email or providing us with
										comments, we may require that you provide personal
										information such as your e-mail address.
									</p>
								</div>
								<br />
								<br />
								<h3 className="title">
									Use of Personal Information by QwixSkinz
								</h3>
								<p>
									QwixSkinz may use the personal information provided in the
									following ways:
								</p>
								<ul className="">
									<li>
										To build and maintain your relationship with QwixSkinz
									</li>
									<li>
										To process service requests and other types of orders.
									</li>
									<li>
										To personalize the delivery of content and information to
										you.
									</li>
									<li>
										QwixSkinz may also use personal information and data
										collected to generate aggregate statistics and reports for
										internal use and for sharing with legitimate statistics
										gathering organizations. These statistics and reports will
										not contain any information that would identify individual
										users of the Site.
									</li>
								</ul>
								<br />
								<br />
								<h3 className="title">Disclosure of Personal Information</h3>
								<p>
									Visitors’ non-aggregated specific personal and account
									information will not be sold, rented or made available to
									anyone other than QwixSkinz unless you have given us express
									permission to do so.
								</p>

								<p>
									QwixSkinz reserves the right to co-operate with law
									enforcement and other officials in any investigation requiring
									either personal or account information, including any
									information provided online through the Site, or reports about
									lawful or unlawful user activities on the Site. QwixSkinz also
									reserves the right at any time to disclose any personal and
									account information: (i) to comply with any applicable law or
									regulation; (ii) if such disclosure is necessary or
									appropriate to site operation; or (iii) to protect the rights
									or property of Instinct for Film and its users, partners,
									providers, licensors or merchants.
								</p>
								<br />
								<br />
								<h3 className="title">Revisions to Privacy Policy</h3>
								<p>
									If Instinct for Film needs to change this Privacy Policy,
									changes will be posted on this Site, so that users are always
									aware of what information is collected, how it is used, and
									under what circumstances it may be disclosed.
								</p>

								<br />
								<br />
								<h3 className="title">Consent</h3>
								<p>
									By using the Site, the user consents to the collection and use
									of personal and account information by QwixSkinz, in
									accordance with this Privacy Policy.
								</p>

								<br />
								<br />
								<h3 className="title">Questions or Comments</h3>
								<p>
									QwixSkinz welcomes your feedback regarding the Site and this
									Privacy Policy. Please contact us by e-mail at
									info@qwixskinz.com
								</p>
							</div>
						</div>
					</div>
				</div>

				<Footer />
				<AnimatedBackground />
			</React.Fragment>
		);
	}
}
